import {
  Component,
  EventEmitter,
  Input,
  HostListener,
  Output,
  ViewChild
} from '@angular/core';
import { UlaModalComponent, UlaTooltipType } from '../ula-modal/ula-modal.component';

@Component({
  selector: 'ula-tooltip',
  templateUrl: 'ula-tooltip.component.html',
  styleUrls: [ './ula-tooltip.component.scss' ]
})
export class UlaTooltipComponent {

  // iconSize is squared - sets the height/width of the icon.
  @Input() iconSize = 20;
  @Input() title: string = null;
  @Input() subtitle: string = null;
  @Input() urgentText: string = null;
  @Input() type: UlaTooltipType = 'simple';

  @Input() showHelpful = false;
  @Input() showPrint = false;

  @Output() helpful: EventEmitter<any> = new EventEmitter();
  @Output() print: EventEmitter<any> = new EventEmitter();

  @ViewChild('modal') modal: UlaModalComponent;

  @HostListener('click', ['$event']) captureClick(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.modal.open();
  }
}
